import { useState } from 'react';
import { useHistory  } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  Alert,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import auth from "authProvider";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";

const Login = () => { 
  const history = useHistory();
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    auth.login({username:e.target.username.value, password:e.target.password.value})
    .then( (resp)=> { 
      //window.location.reload();
      history.push("/")
    })
    .catch( (err) => { setError(true)});
  }
  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Sign in with credentials</small>
            </div>
            <Form role="form" onSubmit={handleSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <IcomoonReact iconSet={iconSet} color="#8898aa" size={14} icon="technician-icon" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Username"
                    type="text"
                    name="username"
                    autoComplete="new-username"
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Password"
                    type="password"
                    name="password"
                    autoComplete="new-password"
                  />
                </InputGroup>
              </FormGroup>
              <div className="custom-control custom-control-alternative custom-checkbox">
                <input
                  className="custom-control-input"
                  id=" customCheckLogin"
                  type="checkbox"
                />
                <label
                  className="custom-control-label"
                  htmlFor=" customCheckLogin"
                >
                  <span className="text-muted">Remember me</span>
                </label>
              </div>
              <div className="text-center">
                <Button className="my-4" color="primary" type="submit">
                  Sign in
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
        <Row className="mt-3">
          <Col xs="6">
            <a
              className="text-light"
              href="#pablo"
              onClick={(e) => e.preventDefault()}
            >
             <Link to="/forgetpassword"><small style={{color:'white'}}>Forgot password?</small></Link>   
            </a>
          </Col>
        </Row>
      </Col>
      <Alert
        color="danger"
        isOpen={error}
        dismissible
        toggle={()=> setError(false)}
        style={{position:'absolute', bottom:80}}>
        Login failed: Incorrect Username or passssword
      </Alert>
    </>
  );
};

export default Login;
